import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const DataSyncService = {
  getSysParams() {
    return httpClient.post(endPoints.getSysParams);
  }
};

export default DataSyncService;



// WEBPACK FOOTER //
// ./src/service/DataSyncService.js